import axios from "axios";

export const fetchConversation = async (path) => {
  const res = await axios.get(`/api${path}/conversation`);
  return res.data;
}

export const updateConversation = async (path, content) => {
  const res = await axios.post(`/api${path}/conversation`, {
    content,
  });
  return res.data;
}

export const editConversationMessage = async (path, messageId, content) => {
  const res = await axios.put(`/api${path}/conversation/${messageId}`, {
    content,
  });
  return res.data;
}

export const deleteConversationMessage = async (path, messageId) => {
  const res = await axios.delete(`/api${path}/conversation/${messageId}`);
  return res.data;
}
